import { qs, qsa, add } from "@fluorescent/dom";
import { ImageReveal, FadeUpReveal, shouldAnimate } from "@/lib/animation";

const selectors = {
  details: ".product__details .animation-fade-up-reveal",
  featuredImage:
    ".product__media-container .product__media-item:not(.hidden) .image",
  remainingImages:
    ".product__media-container .product__media-item.hidden .image",
  detailsLeft: ".product__media-container .animation-fade-up-reveal",
};

export default node => {
  const revealsRight = [];
  const revealsLeft = [];

  const details = qsa(selectors.details, node);
  const featuredImage = qs(selectors.featuredImage, node);
  const remainingImages = qsa(selectors.remainingImages, node);
  const detailsLeft = qsa(selectors.detailsLeft, node);

  if (shouldAnimate(node)) {
    details.forEach(item => {
      revealsRight.push(new FadeUpReveal(item));
    });

    if (featuredImage) {
      revealsLeft.push(new ImageReveal(featuredImage));
    }

    if (remainingImages) {
      add(remainingImages, "animation-initialized");
    }

    detailsLeft.forEach(item => {
      revealsLeft.push(new FadeUpReveal(item));
    });

    revealsRight.forEach((reveal, i) => {
      reveal.play(window.theme.animation.delayExtraShort * i);
    });
    revealsLeft.forEach((reveal, i) => {
      reveal.play(
        window.theme.animation.delayExtraShort * i +
          window.theme.animation.delayExtraShort
      );
    });
  }
};
